import { useQuery } from '@apollo/client';
import {
  DirectionalHint,
  Icon,
  makeStyles,
  Stack,
  Text,
  TooltipHost,
} from '@fluentui/react';
import { Handle, Position } from '@xyflow/react';
import clsx from 'clsx';
import { useCommonStyles } from 'common/styles';
import React from 'react';
import { ApprovalSetupFlowCommonData } from 'settings/account/intuitiveApprovalSetupFlow/__generated__/ApprovalSetupFlowCommonData';
import { useStyles } from '../../../index.styles';
import { movingNodeId } from '../../ApproverLevels';
import { Body } from './body';
import { DeleteTree } from './delete';
import { UpdateTree } from './update';
import APPROVAL_TYPE_DATA from '../../../../ApprovalSetupFlowCommonData.graphql';

// @ts-ignore
export const LevelNode: React.FC = ({ data, isConnectable }) => {

  const styles = useStyles();
  const commonStyles = useCommonStyles();

  const { data: approvalTypes } = useQuery<ApprovalSetupFlowCommonData>(
    APPROVAL_TYPE_DATA,
    {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'cache-only',
    }
  );
  const movingNode = movingNodeId();

  return (
    <Stack style={{ opacity: movingNode && movingNode !== data.id ? 0.5 : 1 }}>
      <Handle
        type="target"
        id={'level-edge'}
        position={Position.Top}
        isConnectable={isConnectable}
      />

      <Handle
        type="source"
        id={'branch-level-edge'}
        position={Position.Right}
        isConnectable={isConnectable}
      />
      <TooltipHost
        content={
          <Stack tokens={{ childrenGap: 16 }} style={{ padding: 5 }}>
            {data?._infoLines?.infoLine1 && (
              <Text variant="small">{data._infoLines.infoLine1}</Text>
            )}
            {data?._infoLines?.infoLine2 && (
              <Text variant="small">{data._infoLines.infoLine2}</Text>
            )}
            {data?._infoLines?.infoLine3 && (
              <Text variant="small">{data._infoLines.infoLine3}</Text>
            )}
            {data?._infoLines?.infoLine4 && (
              <Text variant="small">{data._infoLines.infoLine4}</Text>
            )}
          </Stack>
        }
        directionalHint={DirectionalHint.bottomCenter}
      >
        <Stack className={styles.levelNodeContainer}>
          <Stack
            horizontalAlign="space-between"
            horizontal
            className={styles.approvalLevelNodeHeader}
          >
            <Stack
              className={styles.approvalNodeTitle}
              horizontal
              verticalAlign="center"
              tokens={{ childrenGap: 10 }}
            >
              <Icon
                iconName="UserFollowed"
                style={{ color: 'white' }}
                className={clsx(commonStyles.bold)}
              />
              <Text>
                <Text
                  className={clsx(
                    commonStyles.bold,
                    commonStyles.colorStaticWhite
                  )}
                >
                  {data.name}
                </Text>
              </Text>
            </Stack>

            <Stack
              horizontal
              verticalAlign="center"
              tokens={{ childrenGap: 20 }}
              style={{ height: 30 }}
            >
              <UpdateTree data={data} approvalTypes={approvalTypes} />
              <DeleteTree data={data} />
            </Stack>
          </Stack>
          <Body data={data} />
        </Stack>
      </TooltipHost>
      <Handle
        type="source"
        id={'edge-source'}
        position={Position.Bottom}
        isConnectable={isConnectable}
      />
    </Stack>
  );
};

export const useConditionInfoStyles = makeStyles((theme) => ({
  calloutContainer: {
    backgroundColor: theme.palette.neutralLighterAlt,
  },
  updateConditionCalloutContainer: {
    minWidth: 550,
    width: 400,
    maxHeight: 500,
    overflow: 'hidden',
    backgroundColor: theme.palette.neutralLighterAlt,
  },
}));
